import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { LandingView } from './Landing';
import { ManageListings } from './Listings';
import { CreateListingView } from './Create';
import { EditListingView } from './Edit';
import { ListingView } from './Listing';

export class StratCenterView extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/a/strat-center" component={LandingView} />
                <Route exact path="/a/strat-center/listing/:id" component={ListingView} />
                <Route exact path="/a/strat-center/my-listings" component={ManageListings} />
                <Route exact path="/a/strat-center/my-listings/new" component={CreateListingView} />
                <Route
                    exact
                    path="/a/strat-center/my-listings/:id/edit"
                    component={EditListingView}
                />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/index.js